import { useEffect } from "react";

const HOME_TITLE = "Capsule Chic Hub By Maria Pastor";
const BRAND_SUFFIX = "Capsule Chic Hub";
const SITE_ORIGIN = "https://capsulechichub.com";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`;

function setMetaTag(attr: string, key: string, content: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (el) {
    el.content = content;
  }
}

function absoluteUrl(maybeRelative: string): string {
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${SITE_ORIGIN}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

export function useDocumentTitle(page?: string, description?: string, image?: string) {
  useEffect(() => {
    const title = page ? `${page} | ${BRAND_SUFFIX}` : HOME_TITLE;
    document.title = title;
    setMetaTag("property", "og:title", title);
    setMetaTag("name", "twitter:title", title);

    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
      setMetaTag("name", "twitter:description", description);
    }

    const resolvedImage = image ? absoluteUrl(image) : DEFAULT_OG_IMAGE;
    setMetaTag("property", "og:image", resolvedImage);
    setMetaTag("name", "twitter:image", resolvedImage);
  }, [page, description, image]);
}
